export const TransactionStatusMessage = {
  success:
    "You have successfully purchased the ticket. Please download the ticket from the link below or check your email for the ticket.",
  failed: "Your payment has failed. Please try again.",
  pending:
    "Your payment is pending. Please proceed to the booking page to continue the payment. If you have already paid, please check your booking or contact support if any issue.",
  expired:
    "Your payment link has expired. Please try again or contact support if any issue.",
};
